import TagFilter, { TagFilterMethod } from '../../../components/Operations/TaskSystem/TableComponents/TagFilter'
import EmployeesSelect from '../../../elements/Select/Employee/EmployeesSelect'
import DateFilter, { dateFilterMethod } from '../../../elements/Table/Filters/Date'
import { formatQueryParams } from '../../../modules/Utils'
import moment from 'moment'
import React, { useState } from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Button, Tag } from 'antd'
import DateCell from '../../../elements/Table/Cells/DateCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import { Link, withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import Authentication from '../../../modules/Authentication'

import StatusFilter, { statusFilterMethod } from '../../Operations/TaskSystem/TableComponents/StatusFilter'

const auth = new Authentication()

export const TaskTagsColor = {
  Urgent: '#f50',
  Today: '#2db7f5',
}
const TagsColumn = {
  Header: 'Tags',
  accessor: 'tag',
  width: 150,
  Cell: ({ value }) => {
    return value ? value.map((t) => <Tag color={TaskTagsColor[t] || '#108ee9'}>{t}</Tag>) : value
  },
  filterMethod: TagFilterMethod,
  Filter: TagFilter,
}

const columns = [
  {
    Header: 'ID',
    accessor: '_key',
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/operations/task-system/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Code',
    accessor: 'code',
    width: 200,
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/operations/task-system/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),
  },
  {
    Header: 'MAC',
    accessor: 'enquiry.code',
    width: 200,
    /*Cell: ({value, original}) => (
      <Link
        to={{
          pathname: `/clients/${original.enquiry._id}/update`,
        }}>
        {value}
      </Link>
    ),*/
  },
  {
    Header: 'Origin',
    accessor: 'origin',
    width: 200,
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Activity',
    accessor: 'type',
    width: 200,
    hideable: true,
    hideDefault: true,
  },
  { Header: 'Type', accessor: 'taskType', width: 150 },
  {
    Header: 'Group',
    accessor: 'group.fn',
    width: 150,
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Created On',
    accessor: 'created.date',
    Cell: DateCell,
    hideable: true,
    hideDefault: true,
    width: 200,
  },
  {
    Header: 'Created By',
    accessor: 'created.name.fn',
    hideable: true,
    hideDefault: true,
    width: 200,
  },
  {
    Header: 'Title',
    accessor: 'title',
    style: { marginLeft: 20, alignment: 'left' },
  },
  { Header: 'Assigned To', accessor: 'assignedTo.fn', width: 200 },
  {
    Header: 'Due',
    accessor: 'due.date',
    width: 150,
    Cell: DateCell,
    filterMethod: dateFilterMethod,
    Filter: DateFilter,
  },
  TagsColumn,
  {
    Header: 'Status',
    accessor: 'status',
    width: 150,
    Cell: StatusCell,
    filterMethod: statusFilterMethod,
    Filter: StatusFilter,
  },
]

function TaskSystemList (props) {
  const { list, fetch, fetching, employee, onChangeCompany, hideCompany, enquiry } = props
  console.log({ employee })
  const [filtered, setFiltered] = useState([list])
  const [count, setCount] = useState(0) // weired bug that react only fire render with this

  function onFilteredChangeCustom (value, accessor) {
    let newFiltered = filtered
    let insertNewFilter = 1
    value = value || ''
    if (newFiltered.length > 0) {
      newFiltered.forEach((filter, i) => {
        if (filter['id'] === accessor) {
          if (value === '' || !value.length) newFiltered.splice(i, 1)
          else filter['value'] = value
          insertNewFilter = 0
        }
      })
    }
    if (insertNewFilter) {
      newFiltered.push({ id: accessor, value: value })
    }
    setCount(count + 1) // and this one as well
    console.log({ newFiltered })
    setFiltered(newFiltered)
  }

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      ExtraOptionsButtons={() => (
        <>
          <Tag
            onClick={() => {
              onFilteredChangeCustom([moment(), moment()], 'due.date')
            }}
            style={{ marginRight: 10 }}
            color="magenta">
            Due Today
          </Tag>
          <Tag
            onClick={() => {
              onFilteredChangeCustom([moment().startOf('w'), moment().endOf('w')], 'due.date')
            }}
            style={{ marginRight: 10 }}
            color="blue">
            Due This Week
          </Tag>
          <Tag
            onClick={() => {
              onFilteredChangeCustom([moment().startOf('M'), moment().endOf('M')], 'due.date')
            }}
            style={{ marginRight: 10 }}
            color="geekblue">
            Due This Month
          </Tag>
          {hideCompany !== true && (
            <EmployeesSelect
              value={employee ? employee.value : auth.getMember().fn}
              onChange={onChangeCompany}
              placeholder={'Filter by a Employee'}
              size={'small'}
              style={{ paddingRight: 20, width: 300 }}
            />
          )}
        </>
      )}
      CreateButton={() => (
        <Button
          type={'primary'}
          size="small"
          icon={'plus'}
          onClick={() => {
            props.history.push({
              pathname: `/operations/task-system/new/`,
              search: formatQueryParams('enquiryID', enquiry._id, true),
            })
          }}>
          New Task
        </Button>
      )}
      onFilteredChange={(filtered, column, value) => {
        onFilteredChangeCustom(value, column.id || column.accessor)
      }}
      filtered={filtered}
      columns={columns}
      show={{
        csv: {
          fileName: 'Task-System',
        },
      }}
    />
  )
}

TaskSystemList.propTypes = {
  list: PropTypes.any,
  fetch: PropTypes.any,
  fetching: PropTypes.any,
  employee: PropTypes.any,
  onChangeCompany: PropTypes.any,
  hideCompany: PropTypes.bool,
}
TaskSystemList.defaultProps = {}

export default withRouter(TaskSystemList)
